import axios from "axios";
import Cookies from "js-cookie";

const MAPBOX_TOKEN = 'pk.eyJ1IjoiY29uZ2RvZSIsImEiOiJja205NmhqY2UxZXpuMnVwbTV0dDFvZjh4In0.aadaTJC6ZbASBxqpX8Il3A';

export default class Api {

// RECOMMENDATION
static async getAutoSearch(search, proximity) {
  var query = "&autocomplete=true";

  if(proximity) {
    console.log("PROX: ", proximity)
    query += "&proximity="+proximity;
  }

  const response = await axios.get(

    `https://api.mapbox.com/geocoding/v5/mapbox.places/${search}.json?access_token=${MAPBOX_TOKEN}${query}`
    // `https://api.mapbox.com/geocoding/v5/mapbox.places-permanent/${search}.json?access_token=${MAPBOX_TOKEN}&autocomplete=true`
  );
  return response;
}

  static getBaseUrl() {
    const currentUrl = window.location.href;
    const apiUrls = JSON.parse(process.env.REACT_APP_API_URL);
    if (currentUrl.includes("localhost")) {
      return apiUrls["local"];
    } else if (currentUrl.includes("hostingbucket")) {
      return apiUrls["dev"];
    } else {
      return apiUrls["test"];
    }
  }
}
